<!--横向进度条-->
<template>
	<div class="barBox" :style="getBg" :title="tips">
		<div class="progress" :style="getRate" ></div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {
			rate: {
				type: Number,
				default: 0
			},
			bgColor: {
				type: String,
				default: 'white'
			},
			barColor: {
				type: String,
				default: '#ff8817'
			}
		},
		data() {
			return {}
		},
		created() {},
		mounted() {
			debugPage = this
		},
		destroyed() {},
		computed: {
			getBg() {
				return {
					background: this.bgColor
				}
			},
			getRate() {
				var r = this.rate
				if (this.rate <= 0 || isNaN(this.rate)) {
					r = 0
				}
				if (this.rate >= 100) {
					r = 100
				}
				return {
					background: this.barColor,
					width: r + '%'
				}
			},
			tips() {
				return '占比 ： '+ cutDigital(this.rate) + '%'
			}
		},
		watch: {},
		methods: {

		}
	}
</script>

<style scoped>
	.barBox {
		position: relative;
		display: block;
		overflow: hidden;
		border-radius: 5px;
		cursor: pointer;
	}

	.progress {
		position: absolute;
		z-index: 3;
		left: 0;
		top: 0;
		height: 100%;
		border-radius: 5px;
		transition: width 2s;
		-moz-transition: width 2s;
		/* Firefox 4 */
		-webkit-transition: width 2s;
		/* Safari 和 Chrome */
		-o-transition: width 2s;
		/* Opera */
	}
</style>
